import QuestionInput from "../input/QuestionInput";
import QuestionViewVerbal from "./QuestionViewVerbal";
import QuestionModel from "../../maths/QuestionModel";

export default class QuestionViewVerbalAngle extends QuestionViewVerbal {
    constructor(question) {
        super(question);

        if (question.type === QuestionModel.TYPE_MISSING_ANGLE && question.input === QuestionInput.INPUT_KEYPAD) {
            const unitText = new PIXI.Text("°", {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
            unitText.x = 60;
            unitText.y = -26;
            this.footer.addChild(unitText);
        }
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        //if we didn't define whether or not to use words, then pick randomly
        if (this._question.useWords === undefined) this._question.useWords = P3.math.randomBool();

        if (templates && templates.length > 0)
            templates = templates.slice().filter(x => this.filterTemplate(x));

        if (!templates || !templates.length) return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);

        let text = this._template ? this._template.text : "";
        if (this._template) {
            text = this._replaceUnits(text);

            const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }

            const match = text.match(/\. [a-z]/g);
            if (match) {
                for (let i = 0; i < match.length; ++i) {
                    const s = match[i];
                    text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
                }
            }

        }
        return text;
    }

    _replaceUnits(text) {
        let unit = text.match(/\[UNIT([0-9])?]/g);

        if (unit)
            switch (this.question.type) {
                default: {
                    for (let i = 0; i < unit.length; i++)
                        text = text.replace(unit[i], this.question.units[i].long);
                    break;
                }
                case QuestionModel.TYPE_MISSING_ANGLE: {
                    for (let i = 0; i < unit.length; i++)
                        text = text.replace(unit[i], this.question.unit.long);
                    break;
                }
                case QuestionModel.TYPE_PERIMETER: {
                    for (let i = 0; i < unit.length; i++)
                        text = text.replace(unit[i], this.question.units.long);
                    break;
                }
                case QuestionModel.TYPE_COVERSION_PERCENT_OF_X: {
                    text = text.replace(unit, this.question.units[1].long);
                    break;
                }
                case QuestionModel.TYPE_COVERSION_MULTIPLICATION: {
                    text = text.replace(unit, this._question.units[this._question.units.length - 1].short);
                }
            }

        return text;
    }

    filterTemplate(x) {
        return x.part === this._question.part && x.difficulty === this.question.difficulty;
        //TODO - complete code for positive result template
        /*
        return x.part === this._question.part && x.values === this._question.values.length &&
            x.positiveResult === this._question.positiveResult;
            */

        //return x.part === this._question.part && x.values === this._question.values.length &&
        //   (x.positiveResult !== undefined ? x.positiveResult === this._question.positiveResult : false);
    }
}